import { useAuth } from "../contexts/AuthContext";
import type { Screen } from "../lib/types";

const ITEMS: Array<{ id: Screen; icon: string; key: string }> = [
  { id: "stats",    icon: "📊", key: "tab_stats" },
  { id: "rating",   icon: "🏆", key: "tab_rating" },
  { id: "progress", icon: "📈", key: "tab_progress" },
  { id: "bonus",    icon: "💰", key: "tab_bonus" },
];

export function BottomNav() {
  const { screen, setScreen, t } = useAuth();
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-slate-200 flex" style={{ paddingBottom: "env(safe-area-inset-bottom)" }}>
      {ITEMS.map(item => {
        const active = screen === item.id;
        return (
          <button
            key={item.id}
            onClick={() => setScreen(item.id)}
            className={`flex-1 py-3 flex flex-col items-center gap-0.5 ${active ? "text-indigo-600" : "text-slate-400"}`}
          >
            <span className="text-xl">{item.icon}</span>
            <span className="text-[10px] font-medium">{t(item.key)}</span>
          </button>
        );
      })}
    </nav>
  );
}
